import React, { useState } from 'react';
import { FadeIn, CTAButton } from './Shared';
import { ChevronDown, ChevronUp, Lock, Zap, ShieldCheck } from 'lucide-react';
export const HowItWorks = () => {
  const steps = [{
    num: '01',
    title: 'Bloqueas la Inseguridad',
    desc: "Reemplazas el miedo al error por la confianza del 'Exótico Deseado'."
  }, {
    num: '02',
    title: 'Dominas el Espacio',
    desc: 'Aplicas las técnicas de presencia física que no requieren palabras.'
  }, {
    num: '03',
    title: 'Ejecutas el Cierre',
    desc: "Usas los guiones de 'Broken English' para concretar citas reales."
  }];
  return <section className="py-12 md:py-20 px-4" data-id="element-88">
      <div className="max-w-4xl mx-auto" data-id="element-89">
        <FadeIn data-id="element-90">
          <h3 className="font-playfair text-3xl md:text-4xl text-center mb-10 md:mb-16" data-id="element-91">
            Cómo Funciona
          </h3>
          <div className="grid md:grid-cols-3 gap-5 md:gap-8" data-id="element-92">
            {steps.map((step, i) => <div key={i} className="relative p-6 md:p-8 rounded-lg bg-dark-card border border-dark-border text-center group hover:border-gold/50 transition-all" data-id="element-93">
                <div className="absolute -top-5 left-1/2 -translate-x-1/2 w-10 h-10 md:w-12 md:h-12 bg-dark border-2 border-gold rounded-full flex items-center justify-center font-playfair text-lg md:text-xl font-bold text-gold" data-id="element-94">
                  {step.num}
                </div>
                <h4 className="font-playfair text-lg md:text-xl font-bold text-white mt-3 md:mt-4 mb-2 md:mb-3" data-id="element-95">
                  {step.title}
                </h4>
                <p className="font-inter text-gray-400 text-sm md:text-base" data-id="element-96">
                  {step.desc}
                </p>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const ProofSection = () => {
  return <section className="py-12 md:py-20 px-4 bg-gold text-dark" data-id="element-97">
      <div className="max-w-3xl mx-auto text-center" data-id="element-98">
        <FadeIn data-id="element-99">
          <h3 className="font-playfair text-3xl md:text-4xl font-bold mb-4 md:mb-6" data-id="element-100">
            El Cambio de los 7 Días
          </h3>
          <p className="font-inter text-base md:text-xl font-medium leading-relaxed" data-id="element-101">
            En menos de una semana, dejarás de pedir disculpas por tu acento.
            Notarás cómo las mujeres sostienen más la mirada contigo y cómo el
            ambiente cambia cuando entras a un lugar, simplemente porque tu
            cuerpo ha dejado de enviar señales de "inmigrante inseguro" para
            enviar señales de "hombre de alto valor".
          </p>
        </FadeIn>
      </div>
    </section>;
};
export const FAQSection = () => {
  const faqs = [{
    q: '¿Realmente funciona si mi inglés es muy básico?',
    a: 'Sí. El método está diseñado precisamente para que el poco inglés que sepas proyecte poder, no debilidad.'
  }, {
    q: '¿Las gringas no son racistas o cerradas?',
    a: "La curiosidad sexual es más fuerte que cualquier barrera social. Cuando te posicionas como el 'Exótico Deseado', rompes cualquier prejuicio."
  }, {
    q: '¿Necesito mucho dinero para salir con ellas?',
    a: 'No. Ellas buscan pasión y ambición. El método te enseña a proyectar estatus sin importar lo que ganes por hora.'
  }, {
    q: '¿Recibo el material al instante?',
    a: 'Sí, acceso inmediato en formato PDF para que lo leas en tu teléfono hoy mismo.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 md:py-20 px-4 bg-dark-card" data-id="element-102">
      <div className="max-w-3xl mx-auto" data-id="element-103">
        <FadeIn data-id="element-104">
          <h3 className="font-playfair text-3xl md:text-4xl text-center mb-8 md:mb-12" data-id="element-105">
            Preguntas Frecuentes
          </h3>
          <div className="space-y-3 md:space-y-4" data-id="element-106">
            {faqs.map((faq, i) => <div key={i} className="border border-dark-border rounded-lg overflow-hidden" data-id="element-107">
                <button className="w-full px-4 md:px-6 py-3 md:py-4 text-left flex justify-between items-center bg-black/20 hover:bg-black/40 transition-colors" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-108">
                  <span className="font-inter font-semibold text-white pr-4 text-sm md:text-base" data-id="element-109">
                    {faq.q}
                  </span>
                  {openIndex === i ? <ChevronUp className="text-gold flex-shrink-0 w-5 h-5" data-id="element-110" /> : <ChevronDown className="text-gold flex-shrink-0 w-5 h-5" data-id="element-111" />}
                </button>
                {openIndex === i && <div className="px-4 md:px-6 py-3 md:py-4 bg-black/10 border-t border-dark-border" data-id="element-112">
                    <p className="font-inter text-gray-300 text-sm md:text-base" data-id="element-113">
                      {faq.a}
                    </p>
                  </div>}
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const FinalOffer = () => {
  return <section id="offer" className="py-14 md:py-24 px-4 relative" data-id="element-114">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-gold/10 via-dark to-dark pointer-events-none" data-id="element-115"></div>
      <div className="max-w-2xl mx-auto text-center relative z-10" data-id="element-116">
        <FadeIn data-id="element-117">
          <div className="border-2 border-gold/30 rounded-2xl p-6 md:p-12 bg-black/60 backdrop-blur-sm shadow-2xl shadow-gold/5" data-id="element-118">
            <h3 className="font-playfair text-2xl md:text-4xl text-white mb-4 md:mb-6" data-id="element-119">
              No pagues miles de dólares en cursos de inglés que no te darán una
              cita.
            </h3>
            <p className="font-inter text-gray-300 text-base md:text-lg mb-6 md:mb-8" data-id="element-120">
              Obtén la estrategia definitiva que el 99% de los latinos nunca
              conocerá.
            </p>

            <div className="mb-6 md:mb-8" data-id="element-121">
              <span className="block font-inter text-gray-400 uppercase tracking-widest text-xs md:text-sm mb-1 md:mb-2" data-id="element-122">
                Acceso total por solo
              </span>
              <span className="font-inter text-5xl md:text-7xl font-bold text-gold block tabular-nums" data-id="element-123">
                $6.39
              </span>
            </div>

            <CTAButton className="w-full text-lg md:text-xl py-4 md:py-5 mb-4 md:mb-6" data-id="element-124" />

            <div className="flex flex-col items-center gap-2 md:gap-3 text-xs md:text-sm font-inter text-gray-400" data-id="element-125">
              <div className="flex items-center gap-2" data-id="element-126">
                <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-127" />
                <span data-id="element-128">Pago seguro</span>
                <span className="mx-1 md:mx-2" data-id="element-129">•</span>
                <Zap className="w-4 h-4 text-gold" data-id="element-130" />
                <span data-id="element-131">Descarga inmediata</span>
              </div>
              <p className="text-gray-300 mt-1 italic" data-id="element-132">
                Tu nueva vida en EE.UU. comienza aquí.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};